export const getCompanyPrivacyPolicy = companyInfo => {
  var _companyInfo$data;
  return (companyInfo == null || (_companyInfo$data = companyInfo.data) == null ? void 0 : _companyInfo$data.privacyPolicyUrl) || '';
};
export const getCompanyName = companyInfo => (companyInfo == null ? void 0 : companyInfo.name) || '';
//# sourceMappingURL=companyInfo.js.map